export const APP_CONSTANTS = {
  LS_AUTOREFRESH: 'UIAutoRefresh'
}
